import React, { Component } from "react";
import { Button, FormControl } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getBranchOwner, post, api } from "@config";
import { setLoading } from "@inspinia-react/actions";

const branch = getBranchOwner();

import { ModalUploadError } from "./components/modals";

class UploadCertificate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: "",
      password: "",
      showInfo: false,
      infoText: "",
      infoType: "",
      code: 0,
      message: "",
      modalUploadError: false,
    };
    this.handleAddFile = this.handleAddFile.bind(this);
    this.upload = this.upload.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.uploadResponse = this.uploadResponse.bind(this);
    this.checkFileFormatAndUpload = this.checkFileFormatAndUpload.bind(this);
    this.upload = this.upload.bind(this);
    this.uploadError = this.uploadError.bind(this);
    this.clearInfotext = this.clearInfotext.bind(this);
  }
  fileTypeError() {
    this.setState({
      ...this,
      showInfo: true,
      infoText: (
        <div>
          <p>
            <strong>Formato de arquivo inválido</strong>
          </p>
          <p>
            Localize seu certificado digital com a extenção{" "}
            <strong>.pfx</strong>
          </p>
        </div>
      ),
      infoType: "danger",
    });
  }
  checkFileFormatAndUpload(e, upload = false) {
    this.clearInfotext();
    const file = e.target.files[0];
    const fileType = file.type;
    if (fileType !== "application/x-pkcs12") {
      this.fileTypeError();
      return;
    }
    this.setState({ ...this, file });
    if (this.props.onUpload) this.props.onUpload(file)
  }
  handleAddFile(e) {
    this.checkFileFormat(e);
  }
  handleChangePassword(e) {
    const { value } = e.target;
    this.setState({ ...this, password: value });
    if (this.props.onChangePassword) this.props.onChangePassword(value)
  }

  setInfoText(type, textBody, clear = false) {
    if (clear) {
      this.setState({
        showInfo: false,
        infoText: null,
        infoType: null,
      });
    } else {
      this.setState({
        showInfo: true,
        infoText: textBody,
        infoType: type,
      });
    }
  }

  clearInfotext() {
    this.setState({
      ...this,
      showInfo: false,
      infoType: null,
      infoText: null,
    });
  }

  upload() {
    if (!this.state.file) {
      this.setInfoText(
        "danger",
        <span>
          Selecione o arquivo <strong>.pfx</strong>
        </span>
      );
      return;
    }
    if (!this.state.password) {
      this.setInfoText("warning", "Informe a senha do certificado");
      return;
    }
    this.setInfoText(null, null, true);
    this.props.setLoading(true);
    const formData = new FormData();
    formData.append("branch_owner", branch.id);
    formData.append("password", this.state.password);
    formData.append("file", this.state.file);
    const url = `${api.certificates}?branch_owner=${branch.id}`;
    post(url, formData, this.uploadResponse, this.uploadError);
  }

  uploadError(error) {
    this.props.setLoading(false);
    const err = JSON.parse(error.responseText);
    if (err) {
      if (err.password_error) {
        this.setInfoText("danger", "A senha informada é inválida.");
        return;
      }
      this.setState({
        ...this,
        modalUploadError: true,
        code: err.code,
        message: err.message,
      });
    }
  }

  uploadResponse(response) {
    console.log(response);
    this.props.setLoading(false);
    if (typeof this.props.uploadOk === "function") {
      this.props.uploadOk(response);
    }
    
  }
  render() {
    return (
      <div className="">
        <div className="row py-4">
          <div className="col-6">
            <p>Selecione o arquivo *:</p>
            <input
              className="btn btn-block btn-sm btn-primary"
              type="file"
              disabled={this.props.loading}
              onChange={this.checkFileFormatAndUpload}
            />
          </div>
          <div className="col-6">
            <p>Senha do certificado *:</p>
            <FormControl
              disabled={this.props.loading}
              onChange={this.handleChangePassword}
              type="password"
            />
          </div>
          {/* motivo da remoção desse botão: href não leva a lugar nenhum
          <a className='col-12 mt-2' href="#">Comprar/Renovar certificado</a> */}
        </div>
        {this.state.showInfo ? (
          <p className={`text-${this.state.infoType}`}>{this.state.infoText}</p>
        ) : null}
        {this.props.onUpload ? <div /> : <Button disabled={this.props.loading} onClick={this.upload}>
          {this.props.loading
            ? "Cadastrando... Aguarde um momento, por favor."
            : "Cadastrar Certificado"}
        </Button>}
        <ModalUploadError
          tryAgain={() => {
            this.setState({ ...this, modalUploadError: false });
            this.upload();
          }}
          closeMe={() => this.setState({ ...this, modalUploadError: false })}
          code={this.state.code}
          message={this.state.message}
          show={this.state.modalUploadError}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UploadCertificate);



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/digital-certificate/upload-certificate.jsx